import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import ParlayStatusCircles from "../ParlayStatus/ParlayStatusCircles";
import {selectContestsByIds, selectPrizeAssetById} from "../../stores/pickX/pickX.selectors";
import ParlayRenderer from "../ParlayRenderer/ParlayRenderer";
import {FormattedMessage, useIntl} from "react-intl";
import {ParlayStatus, PayoutModel} from "../../constants/PickXEnums";
import Currency from "../Currency/Currency";
import Tooltip from "@mui/material/Tooltip";
import {selectLocale} from "../../stores/account/account.selectors";
import pickXApi from "../../stores/pickX/pickX.api";
import _ from "lodash";

const ParlaysAccordionItem = ({parlay, isOpen, onHeaderClick}) => {

    //todo: create a selector to retrieve the next game 'selectNextGameByParlayId
    const dispatch = useDispatch();
    const {formatMessage} = useIntl();
    const contestIds = useMemo(() => parlay.contestIds, [parlay.contestIds]);
    const contests = useSelector(state => selectContestsByIds(state, contestIds));

    const getParlayResult = () => {
        if(parlay.Status === ParlayStatus.Completed && parlay.isWon){
                return <div className={"parlayWagerPayout gold-gradient-text"}>({!isPrizeAsset ? <Currency
                    className="gold-gradient-text" value={parlay.Payout}/> : prizeAsset?.[`Name${_.capitalize(locale)}`]})</div>;
            }else if(parlay.isStarted){
                return <Tooltip title={formatMessage({id: 'lobbyView.betSlip.betSlip.probOfWinning'})}
                                placement={"top"}>
                    <div className="percentageOfWin">({parseFloat(parlay.winningOdds).toFixed(0)}%)</div>
                </Tooltip>
            }
    }

    const isPrizeAsset = parlay.PayoutModel === PayoutModel.Assets;
    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, parlay.PrizeAssetId));
    const locale = useSelector(selectLocale);

    useEffect(()=>{
        if (isPrizeAsset && !prizeAsset)
            dispatch(pickXApi.endpoints.getPrizeAssetById.initiate(parlay.PrizeAssetId, {forceRefetch: true}));
    },[isPrizeAsset]);


    return (
        <div className={"ParlaysAccordionItem " + (isOpen ? "open" : "closed")}>
            <div className="parlayAccordionHeader"
                 onClick={onHeaderClick}>
                <div className={"parlay"}>
                    <div className={"parlayName"}>
                        {moment(parlay.DateCreated).format("MMM D")} <FormattedMessage id={`lobbyView.parlayAccordionHeader.${parlay.PayoutModel}`}/> ({parlay.ParlayNum || "✶"})
                    </div>
                    {/*{earliestGame && <div className={"parlayDate"}> @ {moment(earliestGame).format("MMM DD")}</div>}*/}
                </div>
                <div className={"parlayRightHeader"}>
                    <div className="status">
                        <ParlayStatusCircles parlay={parlay} contests={contests} />
                        {getParlayResult()}
                        {/*{parlay.Status === ParlayStatus.Completed && (parlay.isWon ? <div className={`parlayResult won`}/> : <div className={`pickResult lost`}/>)}*/}
                        <div className={"arrow"}>
                            <i className={`fa-solid ${isOpen ? 'fa-angle-down' : 'fa-angle-right'}`}/>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && <ParlayRenderer parlay={parlay}
                                       contests={contests}
                                       prizeAsset={prizeAsset} />}
        </div>
    );
};

export default ParlaysAccordionItem;